module.exports = __webpack_public_path__ + "img/NEWS_025-300x200.b463c516.jpg";